import React, { useEffect, useMemo } from 'react';
import { Select } from 'antd';
import { FORUM_APPID_MAP, FORUM_SITE_MAP_LABEL } from '@/constants/forum';
import styles from './index.module.scss';

interface CountrySelectorProps {
    value: string;
    onChange: (locale: string) => void;
    className?: string;
    availableLocales?: string[];
}

const ALL_OPTIONS = Object.keys(FORUM_APPID_MAP).map((key) => ({
    value: key,
    label: FORUM_SITE_MAP_LABEL[key.toLowerCase()] ?? key.toUpperCase(),
}));

const CountrySelector: React.FC<CountrySelectorProps> = ({ value, onChange, className = '', availableLocales }) => {
    const options = useMemo(() => {
        if (!availableLocales) return ALL_OPTIONS;
        const localeSet = new Set(availableLocales);
        return ALL_OPTIONS.filter((opt) => localeSet.has(opt.value));
    }, [availableLocales]);

    useEffect(() => {
        if (!availableLocales || availableLocales.length === 0) return;
        if (!availableLocales.includes(value) && options.length > 0) {
            onChange(options[0].value);
        }
    }, [availableLocales, value, options, onChange]);

    return (
        <div className={`${styles.countrySelector} ${className}`}>
            <Select value={value} onChange={onChange} options={options} popupMatchSelectWidth={false} size="large" />
        </div>
    );
};

export default CountrySelector;
